import { GET_ACTIVE_AREAS } from "../services/apiUrls";
import { get } from "../services/service";

export const fetchActiveAreas = async (locationId, tenantId) => {
  let response = await get(
    GET_ACTIVE_AREAS.replace("{tenantId}", tenantId).replace(
      "{locationId}",
      locationId
    )
  );
  return response;
};
